import { MutationTree } from 'vuex';
import store from '@/store/store';
import { Error } from '@/store/types';
import { DataAdminSite, AdminSite, AdminSiteState } from './types';

export const mutations: MutationTree<AdminSiteState> = {
  ADMINSITE_SUCCESS: (state, payload: DataAdminSite[]) => {
    state.dataAdminSite = new Array<DataAdminSite>();
    let arrayFilter = payload.sort((a: any, b: any): any => {
      return a.name.localeCompare(b.name);
    });
    arrayFilter.map((value: AdminSite, key: number) => {
      state.dataAdminSite!.push(DataAdminSite.fromJSON(value));
    });
  },
  ADMINSITE_ERROR: (state, payload: Error) => {
    state.dataAdminSite = undefined;
    store.commit('alert/SHOW', {
      prefix: 'ADMINSITE_ERROR_',
      error: payload.status,
    });
  },
  ADMINSITE_ONE_SUCCESS: (state, payload: DataAdminSite) => {
    state.dataAdminSite = new Array<DataAdminSite>();
    state.dataAdminSite!.push(payload);
  },
  ADMINSITE_ONE_ERROR: (state, payload: Error) => {
    store.commit('alert/SHOW', {
      prefix: 'ADMINSITE_ONE_ERROR_',
      error: payload.status,
    });
  },
  ADMINSITE_ADD_ERROR: (state, payload: Error) => {
    store.commit('alert/SHOW', {
      prefix: 'ADMINSITE_ERROR_',
      error: payload.status,
    });
  },
  ADMINSITE_PUT: (state, payload) => {
    if (state.dataAdminSite) {
      for (let i = 0; i < state.dataAdminSite.length; i++) {
        if (payload._id === state.dataAdminSite[i]._id) {
          state.dataAdminSite[i].devices!.push(payload.select);
        } else if (state.dataAdminSite[i]._id === undefined) {
          state.dataAdminSite[i].devices.push(payload.select);
        }
      }
    }
  },
  ADMINSITE_DELETE_ERROR: (state, payload: Error) => {
    state.adminSite = undefined;
    store.commit('alert/SHOW', {
      prefix: 'ADMINSITE_DELETE_ERROR_',
      error: payload.status,
    });
  },
  ADMINSITE_DEVICE_CREATE: (state) => {
    if (state.dataAdminSite && state.dataAdminSite.length === 0) {
      state.dataAdminSite.push(new DataAdminSite());
    } else if (
      state.dataAdminSite &&
      state.dataAdminSite.length !== 0 &&
      state.dataAdminSite[state.dataAdminSite.length - 1]._id &&
      state.dataAdminSite[state.dataAdminSite.length - 1]._id !== undefined
    ) {
      state.dataAdminSite.push(new DataAdminSite());
    }
  },
  ADMINSITE_DEVICE_DELETE: (state, payload) => {
    if (state.dataAdminSite) {
      for (let i = 0; i < state.dataAdminSite.length; i++) {
        if (payload._id === state.dataAdminSite[i]._id) {
          state.dataAdminSite[i].devices!.splice(payload.index, 1);
        }
      }
    }
  },
};
